import { render, staticRenderFns } from "./DeductionsSplit.vue?vue&type=template&id=7a3ee28f&"
import script from "./DeductionsSplit.vue?vue&type=script&lang=js&"
export * from "./DeductionsSplit.vue?vue&type=script&lang=js&"
import style0 from "./DeductionsSplit.vue?vue&type=style&index=0&id=7a3ee28f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports